<template>
  <div class="mr15">
    <div class="comm_view_wrap" style="height:57px;">
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label :label="$t('MSG_CM_TXT_FLDR_NM')" :required="false" :vertical="false" />
        </div>
        <div class="col-xs-10">
          <sui-text-field v-model="forderName" clearable></sui-text-field>
        </div>
      </div>
    </div>
    <div class="comm_btn_act_wrap">
      <button type="button" class="comm_btn_act01" @click="onSave">{{ $t("MSG_CM_BTN_SAVE") }}</button>
      <button type="button" class="comm_btn_act01" @click="onClose">{{ $t("MSG_CM_BTN_CANCEL") }}</button>
    </div>
  </div>
</template>
<script>
  // import - libraries (node modules)
  // import - local files (js, vue, ...)
  // 페이지 에서 사용하는 code 목록 기술
  export default {
    name: 'PGE_CMZ_00002_P01', // eslint-disable-line vue/name-property-casing
    props: {
      closePagePopup: {
        type: Function,
      }
    },
    data() {
      return {
        pageName: "환결설정유형 관리",
        forderName: '',
        // 페이지 에서 사용하는 code 목록이 저장 될 field
      };
    },
    computed: {
      // 계산된 속성, property로 사용가능
    },
    watch: {
      // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
      count() {
        console.log('count increased');
      }
    },
    mounted() {
      // DOM이 document에 append된 상태, 실제 element에 접근 가능 (this.$el or this.$refs)
      // 주로 데이터 패치 등을 함
      this.loadData();
    },
    beforeUpdate() {
      // data 변경전 DOM 정보가 필요한 경우
    },
    updated() {
      // data 변경후 DOM 정보가 필요한 경우
    },
    beforeDestroy() {
      // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
    },
    destroyed() {
      // 남아 있는 자원 반환
    },
    methods: {
      loadData() {
        // get contents data, grid etc..
      },
      onSave() {
        if ('' !== this.forderName) {
          this.closePagePopup(this.forderName);
        } else {
          alert('폴더명을 입력 해주세요.');
        }
      },
      onClose() {
        this.closePagePopup('');
      },
    }
  };
</script>
<style scoped>
</style>
